/**
 * Component phân trang tái sử dụng
 * @param {Object} props
 * @param {number} props.currentPage - Trang hiện tại
 * @param {number} props.totalPages - Tổng số trang
 * @param {number} props.totalItems - Tổng số items
 * @param {Function} props.onPageChange - Callback khi thay đổi trang
 * @param {string} [props.itemName="kết quả"] - Tên loại item để hiển thị
 * @returns {JSX.Element}
 */
export default function Pagination({
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  itemName = "kết quả",
}) {
  if (totalPages <= 1) return null;

  const currentPageNum = parseInt(currentPage);
  const totalPagesNum = parseInt(totalPages);

  // Logic 3 vòng tròn: previous, current, next
  const prevPage = currentPageNum > 1 ? currentPageNum - 1 : null;
  const nextPage = currentPageNum < totalPagesNum ? currentPageNum + 1 : null;

  return (
    <div className="pagination">
      <div className="pagination__info">
        Trang {currentPageNum} / {totalPagesNum} ({totalItems} {itemName})
      </div>

      <div className="pagination__controls">
        {/* Previous page button */}
        <button
          onClick={() => onPageChange(currentPageNum - 1)}
          disabled={currentPageNum === 1}
          className="pagination__btn pagination__btn--nav"
        >
          ← Trước
        </button>

        {/* 3 circles: prev, current, next */}
        <div className="pagination__circles">
          {prevPage && (
            <button
              onClick={() => onPageChange(prevPage)}
              className="pagination__circle pagination__circle--small"
            >
              {prevPage}
            </button>
          )}

          <div className="pagination__circle pagination__circle--current">
            {currentPageNum}
          </div>

          {nextPage && (
            <button
              onClick={() => onPageChange(nextPage)}
              className="pagination__circle pagination__circle--small"
            >
              {nextPage}
            </button>
          )}
        </div>

        {/* Next page button */}
        <button
          onClick={() => onPageChange(currentPageNum + 1)}
          disabled={currentPageNum === totalPagesNum}
          className="pagination__btn pagination__btn--nav"
        >
          Sau →
        </button>
      </div>
    </div>
  );
}
